/**
 * A snapshot that has not changed is not sent.
 *
 * Fifteen times a second every player is sent the players, the orcs and
 * the herd, whether or not any of them moved - and on a quiet evening none
 * of them did. Encoding the same text and pushing it down the same socket
 * fifteen times a second is most of what a small server spends its one
 * core on. So the last text of each kind is kept per link, and the next
 * one goes only when it differs - or once a second regardless, so a
 * reader that goes quiet for a while is not mistaken for one that has gone.
 *
 * Kinds are named rather than everything gated: a "hurt" or a "blocks" is
 * an event, and two identical events a tick apart are two events.
 */

/** The message kinds that are a picture of the world, and so may repeat. */
export const SNAPSHOT_KINDS: ReadonlySet<string> = new Set(["players", "orcs", "herd"]);

/** At least this often, changed or not. */
export const SNAPSHOT_HEARTBEAT_MS = 1000;

export class SnapshotGate {
  private readonly last = new Map<string, { text: string; at: number }>();

  /** Whether this text, of this kind, should go out now. */
  lets(kind: string, text: string, now: number): boolean {
    if (!SNAPSHOT_KINDS.has(kind)) return true;
    const was = this.last.get(kind);
    if (was !== undefined && was.text === text &&
      now - was.at < SNAPSHOT_HEARTBEAT_MS) return false;
    this.last.set(kind, { text, at: now });
    return true;
  }
}
